import { BrowserRouter, Switch, Route } from 'react-router-dom';
import './App.css';
import DashboardContent from './pages/dashboard/Dashboard';
import Pricing from './pages/pricing/Pricing';
import Album from './pages/album/Album';
import Checkout from './pages/checkout/Checkout';
import SignIn from './pages/sign-in/SignIn';
import SignInSide from './pages/sign-in-side/SignInSide';
import SignUp from './pages/sign-up/SignUp';
import Footer from './pages/sticky-footer/StickyFooter';
import LandingPage from './pages/landingpage/LandingPage';
import Home from './pages/onepirate/Home';
import PrivateRoute from './auth/PrivateRoute';


function App() {
  return (
    <div className="App">     
      <BrowserRouter>
        <Switch>
          
          <Route exact path='/' component={Home} /> 
          <Route exact path='/coollanding' component={LandingPage} />  
          {/* The next route is the core route for the entire dashboard
            All views fall into the main dashboard */}
          <PrivateRoute path="/dashboard/:view" exact component={DashboardContent} />  
          <PrivateRoute path="/dashboard/arcGIS" exact component={DashboardContent} />  
          <PrivateRoute path="/dashboard/arcGIS3d" exact component={DashboardContent} />  
          <PrivateRoute path="/dashboard/arcGISEnviro" exact component={DashboardContent} />  

            {/* these are all the dashboard view routes */}
          <PrivateRoute path="/dashboard/main" exact component={DashboardContent} />   
          <PrivateRoute path="/dashboard/projects" exact component={DashboardContent} />   
          <PrivateRoute path="/dashboard/designs" exact component={DashboardContent} />  
          <PrivateRoute path="/dashboard/construction" exact component={DashboardContent} /> 
          <PrivateRoute path="/dashboard/operations" exact component={DashboardContent} /> 
          <PrivateRoute path="/dashboard/analytics" exact component={DashboardContent} /> 
          <PrivateRoute path="/dashboard/visualization" exact component={DashboardContent} /> 
          <PrivateRoute path="/dashboard/management" exact component={DashboardContent} />  
          <PrivateRoute path="/dashboard/bim" exact component={DashboardContent} />  
          <PrivateRoute path="/dashboard/profile" exact component={DashboardContent} />  
          <PrivateRoute path="/dashboard/videofeed" exact component={DashboardContent} />  
                 
          <Route exact path='/album'><Album/></Route> Album 
          <Route exact path='/checkout'><Checkout/></Route>
          <Route exact path='/pricing'><Pricing/></Route>
          <Route exact path='/signin'><SignIn/></Route>
          <Route exact path='/signinside'><SignInSide/></Route>
          <Route exact path='/signup'><SignUp/></Route>
          <Route exact path='/footer'><Footer/></Route>
        </Switch>
      </BrowserRouter>
    
    </div>
  );
}

export default App;
